import React, { memo, useMemo } from 'react';
import _get from 'lodash/get';
import { IAppContextStore, useAppContext } from '../../context/app-context';
import SoundToolsLogo from '../../assets/logo.png';
import { filterItems } from '../../helpers/contentful-helper';
import FooterMenuLink from './footer-menu-link';
import { Entry } from 'contentful';
import { IFooterSection } from './footer.types';

const Footer: React.FC = () => {
  const { rawContentFul }: IAppContextStore = useAppContext();
  const footerSection: Entry<IFooterSection> = useMemo(() => 
    filterItems(rawContentFul, 'newHomepageFooterSection')?.[0] as Entry<IFooterSection>
  , [rawContentFul]);

  return (
    <div className='w-full py-8 px-4 lg:px-0'>
      <div className='mx-auto flex flex-col md:flex-row justify-between gap-6'>
        <a href='/' className='block relative'>
          <img
            src={SoundToolsLogo}
            alt='SoundTools Logo'
            className='object-cover object-center h-[30px] md:h-11 lg:h-14'
          />
        </a>
        <div className='flex flex-col md:flex-row justify-end'>
          <FooterMenuLink
            title={_get(footerSection, 'fields.brands.title')}
            menu={_get(footerSection, 'fields.brands.menu')}
          />
          <FooterMenuLink
            title={_get(footerSection, 'fields.programs.title')}
            menu={_get(footerSection, 'fields.programs.menu')}
          />
          <FooterMenuLink
            title={_get(footerSection, 'fields.about.title')}
            menu={_get(footerSection, 'fields.about.menu')}
          />
        </div>
      </div>
      <hr className='border-[#BABECE] my-8 hidden md:block' />
      <div className='text-center text-[#4E5057]
        leading-4 text-12 max-w-lg mx-auto font-inter mt-10 md:mt-0'>
        {
          _get(
            footerSection,
            'fields.copyright',
            `Copyright © ${new Date().getFullYear()} SoundTools. All Rights Reserved.`
          )
        }
      </div>
    </div>
  )
};

export default memo(Footer);
